import { create } from 'zustand';

/** Clerk `<OrganizationProfile>` page urls (OrgProfileModal.jsx), for deep links. */
export const ORG_PROFILE_PAGE = {
  INFO: 'org-info',
};

/**
 * Whether the organisation-profile modal is open — app-wide, so a page can open
 * it on the tab that edits what it is missing (the UK registration summary's
 * EORI row, docs/features/uk-cbam-registration-summary D14), not only the
 * sidebar's "Manage organization".
 *
 * The profile routes by hash (`routing="hash"`), so opening on a page is
 * setting the hash before the modal mounts; the modal strips it on close.
 * `replaceState`, not `location.hash =`: no history entry for Back to land on.
 */
export const useOrgProfileStore = create((set) => ({
  open: false,
  openOrgProfile: (page) => {
    if (page) {
      const { pathname, search } = window.location;
      window.history.replaceState(null, '', `${pathname}${search}#/${page}`);
    }
    set({ open: true });
  },
  closeOrgProfile: () => set({ open: false }),
}));
